<template>
    <div class="intro-slider">
        <swiper ref="intro" :options="options">
            <swiper-slide v-for="(item, index) in introText" :key="index">
                <IntroSlide :position="index" :head-top="item.headTop" :description="item.description" :img="item.img"
                    :height="item.height" :width="item.width"></IntroSlide>
            </swiper-slide>
            <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
        </swiper>
        <!--        <IosPwaBanner />-->
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import IntroSlide from "../components/Slider/IntroSlide";
// import IosPwaBanner from "../components/UI/IosPwaBanner";
export default {
    components: {
        // IosPwaBanner,
        Swiper,
        SwiperSlide,
        IntroSlide
    },
    name: "Intro",
    directives: {
        swiper: directive
    },
    data() {
        return {
            options: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            introText: {
                "pos-1": {
                    headTop: this.$t("Give + Support"),
                    description: this.$t(
                        "Browse and select from the list of local charities you want to help and make an impact."
                    ),
                    img: "cause",
                    width: "235px",
                    height: "273px"
                },
                "pos-2": {
                    headTop: this.$t("Round Up + Donate"),
                    description: this.$t(
                        "Add your card information and any transaction made through it will be donated to the cause of choice."
                    ),
                    img: "beneficiary",
                    width: "286px",
                    height: "322px"
                },
                "pos-3": {
                    headTop: this.$t("Shop + Save"),
                    description: this.$t(
                        "Explore shops and restaurants in your area that offer you discounts because of your generosity."
                    ),
                    img: "intro-hero",
                    width: "414px",
                    height: "276px"
                },
                "pos-4": {
                    headTop: this.$t("Thank you!"),
                    headBottom: this.$t("A Changemaker"),
                    description: this.$t(
                        "Doing good and getting rewarded has never been so easy. Your local charities can’t thank you enough!"
                    ),
                    img: "thanku-slider",
                    width: "414px",
                    height: "276px"
                }

            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.intro.$swiper;
        }
    },
    mounted() { }
};
</script>

<style>
.swiper-pagination-bullet {
    background: var(--icon-color);
}

.swiper-pagination-bullet-active {
    background: var(--bg-color);
}
</style>